/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface BannerDto
 */
export interface BannerDto {
    /**
     * 
     * @type {string}
     * @memberof BannerDto
     */
    contents?: string;
    /**
     * 
     * @type {number}
     * @memberof BannerDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof BannerDto
     */
    legalText?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BannerDto
     */
    showLegalText?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BannerDto
     */
    subtitle?: string;
    /**
     * 
     * @type {string}
     * @memberof BannerDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof BannerDto
     */
    url?: string;
}
/**
 *
 * @export
 * @interface ContactDto
 */
export interface ContactDto {
    /**
     *
     * @type {string}
     * @memberof ContactDto
     */
    email?: string;
    /**
     *
     * @type {string}
     * @memberof ContactDto
     */
    firstName?: string;
    /**
     *
     * @type {string}
     * @memberof ContactDto
     */
    lastName?: string;
    /**
     *
     * @type {string}
     * @memberof ContactDto
     */
    nationalId?: string;
    /**
     *
     * @type {string}
     * @memberof ContactDto
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactDto
     */
    touchPointSelected?: LoanDtoTouchPointSelectedEnum;
}
/**
 * 
 * @export
 * @interface CreatedLeadDto
 */
export interface CreatedLeadDto {
    /**
     * 
     * @type {number}
     * @memberof CreatedLeadDto
     */
    id?: number;
    /**
     * 
     * @type {KnockOutDto}
     * @memberof CreatedLeadDto
     */
    knockOutDto?: KnockOutDto;
    /**
     * 
     * @type {string}
     * @memberof CreatedLeadDto
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof CreatedLeadDto
     */
    version?: number;
}
/**
 * 
 * @export
 * @interface FinancialInstitutionDto
 */
export interface FinancialInstitutionDto {
    /**
     * 
     * @type {number}
     * @memberof FinancialInstitutionDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof FinancialInstitutionDto
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface IdentityDto
 */
export interface IdentityDto {
    /**
     * 
     * @type {string}
     * @memberof IdentityDto
     */
    nationalId?: string;
    /**
     * 
     * @type {string}
     * @memberof IdentityDto
     */
    serialNumberId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityDto
     */
    validate?: boolean;
}
/**
 * 
 * @export
 * @interface JobDocumentDto
 */
export interface JobDocumentDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof JobDocumentDto
     */
    formatPermit?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JobDocumentDto
     */
    subtitle?: string;
    /**
     * 
     * @type {string}
     * @memberof JobDocumentDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof JobDocumentDto
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface KnockOutDto
 */
export interface KnockOutDto {
    /**
     * 
     * @type {string}
     * @memberof KnockOutDto
     */
    status?: KnockOutDtoStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum KnockOutDtoStatusEnum {
    Bueno = 'Bueno',
    Malo = 'Malo'
}

/**
 * 
 * @export
 * @interface Link
 */
export interface Link {
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    href?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Link
     */
    templated?: boolean;
}
/**
 * 
 * @export
 * @interface LoanDocumentDto
 */
export interface LoanDocumentDto {
    /**
     * 
     * @type {string}
     * @memberof LoanDocumentDto
     */
    documentType: string;
    /**
     * 
     * @type {string}
     * @memberof LoanDocumentDto
     */
    extension: string;
    /**
     * 
     * @type {number}
     * @memberof LoanDocumentDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof LoanDocumentDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LoanDocumentDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanDocumentDto
     */
    url: string;
}
/**
 * 
 * @export
 * @interface LoanDto
 */
export interface LoanDto {
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    actionId?: LoanDtoActionIdEnum;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    campaign?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    crmIdentifier?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    dateOfEmployment?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanDto
     */
    discountInterestRate?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanDto
     */
    downPayment?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    fbc?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    fbp?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    flow?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    gid?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    jobType?: LoanDtoJobTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    lastName?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanDto
     */
    loanInstallmentNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    medium?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    nationalId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LoanDto
     */
    overSixInstallment?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    plate?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanDto
     */
    salary?: number;
    /**
     * 
     * @type {SimulationResponseDto}
     * @memberof LoanDto
     */
    simulation?: SimulationResponseDto;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    sourceUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    touchPointSelected?: LoanDtoTouchPointSelectedEnum;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    trafficSources?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanDto
     */
    userAgent?: string;
    /**
     * 
     * @type {number}
     * @memberof LoanDto
     */
    vehicleValue?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanDto
     */
    vehicleYear?: number;
    /**
     * 
     * @type {number}
     * @memberof LoanDto
     */
    version?: number;
}

/**
 * 
 * @export
 * @interface QuotationDto
 */
export interface QuotationDto {
    /**
     * 
     * @type {string}
     * @memberof LeadDto
     */
    nombreCompleto?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadDto
     */
    rut?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadDto
     */
    correo?: string;
    /**
     * 
     * @type {string}
     * @memberof LeadDto
     */
    telefono?: string;
    /**
     * 
     * @type {number}
     * @memberof LeadDto
     */
    idVehiculo?: number;
}


/**
    * @export
    * @enum {string}
    */
export enum LoanDtoActionIdEnum {
    AsyncScoringAndFinish = 'ASYNC_SCORING_AND_FINISH',
    Finish = 'FINISH',
    Knockout = 'KNOCKOUT',
    KnockoutAndFinish = 'KNOCKOUT_AND_FINISH',
    LoanNotificationDocumentH2 = 'LOAN_NOTIFICATION_DOCUMENT_H2',
    Scoring = 'SCORING',
    ScoringAndFinish = 'SCORING_AND_FINISH',
    ScoringAndUpdate = 'SCORING_AND_UPDATE',
    UpdateLoanLead = 'UPDATE_LOAN_LEAD'
}
/**
    * @export
    * @enum {string}
    */
export enum LoanDtoJobTypeEnum {
    Dependiente = 'Dependiente',
    Independiente = 'Independiente'
}
/**
    * @export
    * @enum {string}
    */
export enum LoanDtoTouchPointSelectedEnum {
    Email = 'EMAIL',
    Phone = 'PHONE',
    Whatsapp = 'WHATSAPP'
}

/**
 * 
 * @export
 * @interface ModelAndView
 */
export interface ModelAndView {
    /**
     * 
     * @type {boolean}
     * @memberof ModelAndView
     */
    empty?: boolean;
    /**
     * 
     * @type {object}
     * @memberof ModelAndView
     */
    model?: object;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ModelAndView
     */
    modelMap?: { [key: string]: object; };
    /**
     * 
     * @type {boolean}
     * @memberof ModelAndView
     */
    reference?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ModelAndView
     */
    status?: ModelAndViewStatusEnum;
    /**
     * 
     * @type {View}
     * @memberof ModelAndView
     */
    view?: View;
    /**
     * 
     * @type {string}
     * @memberof ModelAndView
     */
    viewName?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ModelAndViewStatusEnum {
    Accepted = 'ACCEPTED',
    AlreadyReported = 'ALREADY_REPORTED',
    BadGateway = 'BAD_GATEWAY',
    BadRequest = 'BAD_REQUEST',
    BandwidthLimitExceeded = 'BANDWIDTH_LIMIT_EXCEEDED',
    Checkpoint = 'CHECKPOINT',
    Conflict = 'CONFLICT',
    Continue = 'CONTINUE',
    Created = 'CREATED',
    DestinationLocked = 'DESTINATION_LOCKED',
    ExpectationFailed = 'EXPECTATION_FAILED',
    FailedDependency = 'FAILED_DEPENDENCY',
    Forbidden = 'FORBIDDEN',
    Found = 'FOUND',
    GatewayTimeout = 'GATEWAY_TIMEOUT',
    Gone = 'GONE',
    HttpVersionNotSupported = 'HTTP_VERSION_NOT_SUPPORTED',
    ImUsed = 'IM_USED',
    InsufficientSpaceOnResource = 'INSUFFICIENT_SPACE_ON_RESOURCE',
    InsufficientStorage = 'INSUFFICIENT_STORAGE',
    InternalServerError = 'INTERNAL_SERVER_ERROR',
    IAmATeapot = 'I_AM_A_TEAPOT',
    LengthRequired = 'LENGTH_REQUIRED',
    Locked = 'LOCKED',
    LoopDetected = 'LOOP_DETECTED',
    MethodFailure = 'METHOD_FAILURE',
    MethodNotAllowed = 'METHOD_NOT_ALLOWED',
    MovedPermanently = 'MOVED_PERMANENTLY',
    MovedTemporarily = 'MOVED_TEMPORARILY',
    MultipleChoices = 'MULTIPLE_CHOICES',
    MultiStatus = 'MULTI_STATUS',
    NetworkAuthenticationRequired = 'NETWORK_AUTHENTICATION_REQUIRED',
    NonAuthoritativeInformation = 'NON_AUTHORITATIVE_INFORMATION',
    NotAcceptable = 'NOT_ACCEPTABLE',
    NotExtended = 'NOT_EXTENDED',
    NotFound = 'NOT_FOUND',
    NotImplemented = 'NOT_IMPLEMENTED',
    NotModified = 'NOT_MODIFIED',
    NoContent = 'NO_CONTENT',
    Ok = 'OK',
    PartialContent = 'PARTIAL_CONTENT',
    PayloadTooLarge = 'PAYLOAD_TOO_LARGE',
    PaymentRequired = 'PAYMENT_REQUIRED',
    PermanentRedirect = 'PERMANENT_REDIRECT',
    PreconditionFailed = 'PRECONDITION_FAILED',
    PreconditionRequired = 'PRECONDITION_REQUIRED',
    Processing = 'PROCESSING',
    ProxyAuthenticationRequired = 'PROXY_AUTHENTICATION_REQUIRED',
    RequestedRangeNotSatisfiable = 'REQUESTED_RANGE_NOT_SATISFIABLE',
    RequestEntityTooLarge = 'REQUEST_ENTITY_TOO_LARGE',
    RequestHeaderFieldsTooLarge = 'REQUEST_HEADER_FIELDS_TOO_LARGE',
    RequestTimeout = 'REQUEST_TIMEOUT',
    RequestUriTooLong = 'REQUEST_URI_TOO_LONG',
    ResetContent = 'RESET_CONTENT',
    SeeOther = 'SEE_OTHER',
    ServiceUnavailable = 'SERVICE_UNAVAILABLE',
    SwitchingProtocols = 'SWITCHING_PROTOCOLS',
    TemporaryRedirect = 'TEMPORARY_REDIRECT',
    TooEarly = 'TOO_EARLY',
    TooManyRequests = 'TOO_MANY_REQUESTS',
    Unauthorized = 'UNAUTHORIZED',
    UnavailableForLegalReasons = 'UNAVAILABLE_FOR_LEGAL_REASONS',
    UnprocessableEntity = 'UNPROCESSABLE_ENTITY',
    UnsupportedMediaType = 'UNSUPPORTED_MEDIA_TYPE',
    UpgradeRequired = 'UPGRADE_REQUIRED',
    UriTooLong = 'URI_TOO_LONG',
    UseProxy = 'USE_PROXY',
    VariantAlsoNegotiates = 'VARIANT_ALSO_NEGOTIATES'
}

/**
 * 
 * @export
 * @interface NotificationDocument
 */
export interface NotificationDocument {
    /**
     * 
     * @type {string}
     * @memberof NotificationDocument
     */
    crmIdentifier?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDocument
     */
    urlReturn?: string;
}
/**
 * 
 * @export
 * @interface PortabilityDto
 */
export interface PortabilityDto {
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    actionId?: PortabilityDtoActionIdEnum;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    campaign?: string;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    crmIdentifier?: string;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    dateOfEmployment?: string;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PortabilityDto
     */
    error?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    errorDetail?: string;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    fbc?: string;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    fbp?: string;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    financialInstitutionName?: string;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    flow?: string;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    gid?: string;
    /**
     * 
     * @type {number}
     * @memberof PortabilityDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    lastName?: string;
    /**
     * 
     * @type {number}
     * @memberof PortabilityDto
     */
    loanInstallmentNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    locality?: string;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    medium?: string;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    nationalId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PortabilityDto
     */
    overSixInstallment?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PortabilityDto
     */
    paidInstallmentNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    region?: string;
    /**
     * 
     * @type {number}
     * @memberof PortabilityDto
     */
    salary?: number;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    serialNumberId?: string;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    settlementCertificateId?: string;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    sourceUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    touchPointSelected?: PortabilityDtoTouchPointSelectedEnum;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    trafficSources?: string;
    /**
     * 
     * @type {string}
     * @memberof PortabilityDto
     */
    userAgent?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof PortabilityDto
     */
    vehiclePlate?: Set<string>;
    /**
     * 
     * @type {number}
     * @memberof PortabilityDto
     */
    vehicleValue?: number;
    /**
     * 
     * @type {number}
     * @memberof PortabilityDto
     */
    vehicleYear?: number;
    /**
     * 
     * @type {number}
     * @memberof PortabilityDto
     */
    version?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum PortabilityDtoActionIdEnum {
    AsyncScoringAndFinish = 'ASYNC_SCORING_AND_FINISH',
    Finish = 'FINISH',
    Knockout = 'KNOCKOUT',
    KnockoutAndFinish = 'KNOCKOUT_AND_FINISH',
    LoanNotificationDocumentH2 = 'LOAN_NOTIFICATION_DOCUMENT_H2',
    Scoring = 'SCORING',
    ScoringAndFinish = 'SCORING_AND_FINISH',
    ScoringAndUpdate = 'SCORING_AND_UPDATE',
    UpdateLoanLead = 'UPDATE_LOAN_LEAD'
}
/**
    * @export
    * @enum {string}
    */
export enum PortabilityDtoTouchPointSelectedEnum {
    Email = 'EMAIL',
    Phone = 'PHONE',
    Whatsapp = 'WHATSAPP'
}

/**
 * 
 * @export
 * @interface RequestRefinancingDto
 */
export interface RequestRefinancingDto {
    /**
     * 
     * @type {string}
     * @memberof RequestRefinancingDto
     */
    campaign?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRefinancingDto
     */
    email: string;
    /**
     * 
     * @type {number}
     * @memberof RequestRefinancingDto
     */
    financialInstitution: number;
    /**
     * 
     * @type {string}
     * @memberof RequestRefinancingDto
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRefinancingDto
     */
    flow?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestRefinancingDto
     */
    installmentNumber: number;
    /**
     * 
     * @type {string}
     * @memberof RequestRefinancingDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRefinancingDto
     */
    medium?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRefinancingDto
     */
    nationalId: string;
    /**
     * 
     * @type {number}
     * @memberof RequestRefinancingDto
     */
    phone: number;
    /**
     * 
     * @type {number}
     * @memberof RequestRefinancingDto
     */
    salary: number;
    /**
     * 
     * @type {string}
     * @memberof RequestRefinancingDto
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestRefinancingDto
     */
    trafficSources?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestRefinancingDto
     */
    vehicleValue: number;
    /**
     * 
     * @type {number}
     * @memberof RequestRefinancingDto
     */
    vehicleYear: number;
}
/**
 * 
 * @export
 * @interface Resource
 */
export interface Resource {
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    description?: string;
    /**
     * 
     * @type {any}
     * @memberof Resource
     */
    file?: any;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    filename?: string;
    /**
     * 
     * @type {object}
     * @memberof Resource
     */
    inputStream?: object;
    /**
     * 
     * @type {boolean}
     * @memberof Resource
     */
    open?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Resource
     */
    readable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    uri?: string;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    url?: string;
}
/**
 * 
 * @export
 * @interface ResponseRefinancingDto
 */
export interface ResponseRefinancingDto {
    /**
     * 
     * @type {string}
     * @memberof ResponseRefinancingDto
     */
    crmIdentifier?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseRefinancingDto
     */
    state?: string;
}
/**
 * 
 * @export
 * @interface ResultDto
 */
export interface ResultDto {
    /**
     * 
     * @type {string}
     * @memberof ResultDto
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultDto
     */
    state?: ResultDtoStateEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ResultDtoStateEnum {
    EcertNok = 'ECERT_NOK',
    EcertOk = 'ECERT_OK',
    Error = 'ERROR',
    Ok = 'OK'
}

/**
 * 
 * @export
 * @interface ScoringDto
 */
export interface ScoringDto {
    /**
     * 
     * @type {string}
     * @memberof ScoringDto
     */
    color?: ScoringDtoColorEnum;
    /**
     * 
     * @type {string}
     * @memberof ScoringDto
     */
    message?: string;
    /**
     * 
     * @type {number}
     * @memberof ScoringDto
     */
    simulationId?: number;
    /**
     * 
     * @type {number}
     * @memberof ScoringDto
     */
    statusCode?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum ScoringDtoColorEnum {
    Amarillo = 'Amarillo',
    Morado = 'Morado',
    Naranjo = 'Naranjo',
    Rojo = 'Rojo',
    Verde = 'Verde'
}

/**
 * 
 * @export
 * @interface SimulationResponseDto
 */
export interface SimulationResponseDto {
    /**
     * 
     * @type {number}
     * @memberof SimulationResponseDto
     */
    cae?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationResponseDto
     */
    discountInterestRate?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationResponseDto
     */
    discountPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationResponseDto
     */
    downPaymentPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationResponseDto
     */
    installmentAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationResponseDto
     */
    installmentNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationResponseDto
     */
    interestRate?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationResponseDto
     */
    loanAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationResponseDto
     */
    loanTaxes?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationResponseDto
     */
    reliefInsurance?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationResponseDto
     */
    totalLoanCost?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationResponseDto
     */
    totalSurchages?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationResponseDto
     */
    unemploymentInsurance?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationResponseDto
     */
    vmfg?: number;
}
/**
 * 
 * @export
 * @interface TokenResponseDto
 */
export interface TokenResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TokenResponseDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenResponseDto
     */
    token?: string;
}
/**
 * 
 * @export
 * @interface UpdatedLeadDto
 */
export interface UpdatedLeadDto {
	map(arg0: (item: any) => any): Iterable<unknown> | null | undefined;
    /**
     * 
     * @type {string}
     * @memberof UpdatedLeadDto
     */
    crmIdentifier?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdatedLeadDto
     */
    id?: number;
    /**
     * 
     * @type {SimulationResponseDto}
     * @memberof UpdatedLeadDto
     */
    indexaSimulation?: SimulationResponseDto;
    /**
     * 
     * @type {KnockOutDto}
     * @memberof UpdatedLeadDto
     */
    knockOut?: KnockOutDto;
    /**
     * 
     * @type {ResultDto}
     * @memberof UpdatedLeadDto
     */
    result?: ResultDto;
    /**
     * 
     * @type {ScoringDto}
     * @memberof UpdatedLeadDto
     */
    scoring?: ScoringDto;
    /**
     * 
     * @type {string}
     * @memberof UpdatedLeadDto
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdatedLeadDto
     */
    version?: number;
}
/**
 * 
 * @export
 * @interface UploadedDocumentDto
 */
export interface UploadedDocumentDto {
    /**
     * 
     * @type {string}
     * @memberof UploadedDocumentDto
     */
    documentType: string;
    /**
     * 
     * @type {string}
     * @memberof UploadedDocumentDto
     */
    extension: string;
    /**
     * 
     * @type {number}
     * @memberof UploadedDocumentDto
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof UploadedDocumentDto
     */
    idNexus?: number;
    /**
     * 
     * @type {string}
     * @memberof UploadedDocumentDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UploadedDocumentDto
     */
    nationalId: string;
    /**
     * 
     * @type {string}
     * @memberof UploadedDocumentDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadedDocumentDto
     */
    url: string;
}
/**
 * 
 * @export
 * @interface UploadedLoanDocumentDto
 */
export interface UploadedLoanDocumentDto {
    /**
     * 
     * @type {string}
     * @memberof UploadedLoanDocumentDto
     */
    action?: UploadedLoanDocumentDtoActionEnum;
    /**
     * 
     * @type {Array<JobDocumentDto>}
     * @memberof UploadedLoanDocumentDto
     */
    documentType?: Array<JobDocumentDto>;
    /**
     * 
     * @type {boolean}
     * @memberof UploadedLoanDocumentDto
     */
    isInstant?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UploadedLoanDocumentDto
     */
    jobType?: string;
    /**
     * 
     * @type {Array<LoanDocumentDto>}
     * @memberof UploadedLoanDocumentDto
     */
    loanDocument?: Array<LoanDocumentDto>;
}

/**
    * @export
    * @enum {string}
    */
export enum UploadedLoanDocumentDtoActionEnum {
    WithoutDocument = 'WITHOUT_DOCUMENT',
    WithDocument = 'WITH_DOCUMENT'
}

/**
 * 
 * @export
 * @interface View
 */
export interface View {
    /**
     * 
     * @type {string}
     * @memberof View
     */
    contentType?: string;
}

/**
 *
 * @export
 * @interface RequestPrepaid
 */
export interface RequestPrepaid {
    firstname: string;
    lastname: string;
    rut: string;
    renta: string;
    phone: number;
    email: string;
    financiera: string;
    operacion: string;
    emailFinanciera: string;
    rutFinanciera:string;
    patente:string;
    origen:string;
    base64:string;
    fileName?:string;
}

/**
 * * ContactControllerApi - axios parameter creator
 * @export
 */
export const RequestPrepaidControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Create new Contact
         * @param {string} authorization Authorization
         * @param requestPrepaid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRequestPrepaidUsingPOST: async (authorization: string, requestPrepaid: RequestPrepaid, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            // assertParamExists('createContactUsingPOST', 'authorization', authorization)
            // verify required parameter 'contactDto' is not null or undefined
            assertParamExists('createContactUsingPOSTcreateRequestPrepaidUsingPOST', 'requestPrepaid', requestPrepaid)
            const localVarPath = `/requestPrepaid/create/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestPrepaid, localVarRequestOptions, configuration)
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactControllerApi - functional programming interface
 * @export
 */
export const RequestPrepaidControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RequestPrepaidControllerApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Create new Contact
         * @param authorization
         * @param requestPrepaid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRequestPrepaidUsingPOST(authorization: string, requestPrepaid: RequestPrepaid, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRequestPrepaidUsingPOST(authorization, requestPrepaid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RequestPrepaidControllerApi - object-oriented interface
 * @export
 * @class RequestPrepaidControllerApi
 * @extends {BaseAPI}
 */
export class RequestPrepaidControllerApi extends BaseAPI {
    /**
     *
     * @summary Create new Contact
     * @param requestPrepaid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactControllerApi
     */
    public createRequestPrepaidUsingPOST(authorization: string, requestPrepaid: RequestPrepaid, options?: any) {
        return RequestPrepaidControllerApiFp(this.configuration).createRequestPrepaidUsingPOST(authorization, requestPrepaid, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * AuthControllerApi - axios parameter creator
 * @export
 */
export const AuthControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Login
         * @param {string} authorization Authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginUsingGET: async (authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('loginUsingGET', 'authorization', authorization)
            const localVarPath = `/auth/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthControllerApi - functional programming interface
 * @export
 */
export const AuthControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Login
         * @param {string} authorization Authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginUsingGET(authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthControllerApi - factory interface
 * @export
 */
export const AuthControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Login
         * @param {string} authorization Authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginUsingGET(authorization: string, options?: any): AxiosPromise<TokenResponseDto> {
            return localVarFp.loginUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthControllerApi - object-oriented interface
 * @export
 * @class AuthControllerApi
 * @extends {BaseAPI}
 */
export class AuthControllerApi extends BaseAPI {
    /**
     * 
     * @summary Login
     * @param {string} authorization Authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthControllerApi
     */
    public loginUsingGET(authorization: string, options?: any) {
        return AuthControllerApiFp(this.configuration).loginUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BasicErrorControllerApi - axios parameter creator
 * @export
 */
export const BasicErrorControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary errorHtml
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorHtmlUsingDELETE: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/error`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary errorHtml
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorHtmlUsingGET: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/error`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary errorHtml
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorHtmlUsingHEAD: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/error`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'HEAD', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary errorHtml
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorHtmlUsingOPTIONS: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/error`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'OPTIONS', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary errorHtml
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorHtmlUsingPATCH: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/error`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary errorHtml
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorHtmlUsingPOST: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/error`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary errorHtml
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorHtmlUsingPUT: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/error`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BasicErrorControllerApi - functional programming interface
 * @export
 */
export const BasicErrorControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BasicErrorControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary errorHtml
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async errorHtmlUsingDELETE(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelAndView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.errorHtmlUsingDELETE(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary errorHtml
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async errorHtmlUsingGET(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelAndView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.errorHtmlUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary errorHtml
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async errorHtmlUsingHEAD(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelAndView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.errorHtmlUsingHEAD(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary errorHtml
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async errorHtmlUsingOPTIONS(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelAndView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.errorHtmlUsingOPTIONS(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary errorHtml
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async errorHtmlUsingPATCH(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelAndView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.errorHtmlUsingPATCH(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary errorHtml
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async errorHtmlUsingPOST(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelAndView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.errorHtmlUsingPOST(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary errorHtml
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async errorHtmlUsingPUT(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModelAndView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.errorHtmlUsingPUT(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BasicErrorControllerApi - factory interface
 * @export
 */
export const BasicErrorControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BasicErrorControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary errorHtml
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorHtmlUsingDELETE(options?: any): AxiosPromise<ModelAndView> {
            return localVarFp.errorHtmlUsingDELETE(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary errorHtml
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorHtmlUsingGET(options?: any): AxiosPromise<ModelAndView> {
            return localVarFp.errorHtmlUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary errorHtml
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorHtmlUsingHEAD(options?: any): AxiosPromise<ModelAndView> {
            return localVarFp.errorHtmlUsingHEAD(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary errorHtml
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorHtmlUsingOPTIONS(options?: any): AxiosPromise<ModelAndView> {
            return localVarFp.errorHtmlUsingOPTIONS(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary errorHtml
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorHtmlUsingPATCH(options?: any): AxiosPromise<ModelAndView> {
            return localVarFp.errorHtmlUsingPATCH(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary errorHtml
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorHtmlUsingPOST(options?: any): AxiosPromise<ModelAndView> {
            return localVarFp.errorHtmlUsingPOST(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary errorHtml
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        errorHtmlUsingPUT(options?: any): AxiosPromise<ModelAndView> {
            return localVarFp.errorHtmlUsingPUT(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BasicErrorControllerApi - object-oriented interface
 * @export
 * @class BasicErrorControllerApi
 * @extends {BaseAPI}
 */
export class BasicErrorControllerApi extends BaseAPI {
    /**
     * 
     * @summary errorHtml
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasicErrorControllerApi
     */
    public errorHtmlUsingDELETE(options?: any) {
        return BasicErrorControllerApiFp(this.configuration).errorHtmlUsingDELETE(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary errorHtml
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasicErrorControllerApi
     */
    public errorHtmlUsingGET(options?: any) {
        return BasicErrorControllerApiFp(this.configuration).errorHtmlUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary errorHtml
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasicErrorControllerApi
     */
    public errorHtmlUsingHEAD(options?: any) {
        return BasicErrorControllerApiFp(this.configuration).errorHtmlUsingHEAD(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary errorHtml
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasicErrorControllerApi
     */
    public errorHtmlUsingOPTIONS(options?: any) {
        return BasicErrorControllerApiFp(this.configuration).errorHtmlUsingOPTIONS(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary errorHtml
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasicErrorControllerApi
     */
    public errorHtmlUsingPATCH(options?: any) {
        return BasicErrorControllerApiFp(this.configuration).errorHtmlUsingPATCH(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary errorHtml
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasicErrorControllerApi
     */
    public errorHtmlUsingPOST(options?: any) {
        return BasicErrorControllerApiFp(this.configuration).errorHtmlUsingPOST(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary errorHtml
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasicErrorControllerApi
     */
    public errorHtmlUsingPUT(options?: any) {
        return BasicErrorControllerApiFp(this.configuration).errorHtmlUsingPUT(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * * ContactControllerApi - axios parameter creator
 * @export
 */
export const ContactControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Create new Contact
         * @param {string} authorization Authorization
         * @param {ContactDto} contactDto contactDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactUsingPOST: async (authorization: string, contactDto: ContactDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createContactUsingPOST', 'authorization', authorization)
            // verify required parameter 'contactDto' is not null or undefined
            assertParamExists('createContactUsingPOST', 'contactDto', contactDto)
            const localVarPath = `/contact/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
    
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactDto, localVarRequestOptions, configuration)
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};
/**
 * ContactControllerApi - functional programming interface
 * @export
 */
export const ContactControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactControllerApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Create new Contact
         * @param {string} authorization Authorization
         * @param {ContactDto} contactDto contactDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContactUsingPOST(authorization: string, contactDto: ContactDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createContactUsingPOST(authorization, contactDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};
/**
 * ContactControllerApi - factory interface
 * @export
 */
export const ContactControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactControllerApiFp(configuration)
    return {
        /**
         *
         * @summary Create new Contact
         * @param {string} authorization Authorization
         * @param {ContactDto} contactDto contactDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactUsingPOST(authorization: string, contactDto: ContactDto, options?: any): AxiosPromise<boolean> {
            return localVarFp.createContactUsingPOST(authorization, contactDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ContactControllerApi - object-oriented interface
 * @export
 * @class ContactControllerApi
 * @extends {BaseAPI}
 */
export class ContactControllerApi extends BaseAPI {
    /**
     *
     * @summary Create new Contact
     * @param {string} authorization Authorization
     * @param {ContactDto} contactDto contactDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactControllerApi
     */
    public createContactUsingPOST(authorization: string, contactDto: ContactDto, options?: any) {
        return ContactControllerApiFp(this.configuration).createContactUsingPOST(authorization, contactDto, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * DocumentControllerApi - axios parameter creator
 * @export
 */
export const DocumentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Document Portability
         * @param {string} authorization Authorization
         * @param {number} [id] id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPortabilityDocumentUsingGET: async (authorization: string, id?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createPortabilityDocumentUsingGET', 'authorization', authorization)
            const localVarPath = `/document/portability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Document Loan
         * @param {string} authorization Authorization
         * @param {number} documentId documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLoanDocumentUsingDELETE: async (authorization: string, documentId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteLoanDocumentUsingDELETE', 'authorization', authorization)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('deleteLoanDocumentUsingDELETE', 'documentId', documentId)
            const localVarPath = `/document/loan/{documentId}/delete`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch Document
         * @param {string} authorization Authorization
         * @param {number} id id
         * @param {string} nationalId nationalId
         * @param {'INDEXA' | 'LOAN' | 'PORTABILITY'} operationKey operationKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDocumentUsingGET: async (authorization: string, id: number, nationalId: string, operationKey: 'INDEXA' | 'LOAN' | 'PORTABILITY', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('fetchDocumentUsingGET', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('fetchDocumentUsingGET', 'id', id)
            // verify required parameter 'nationalId' is not null or undefined
            assertParamExists('fetchDocumentUsingGET', 'nationalId', nationalId)
            // verify required parameter 'operationKey' is not null or undefined
            assertParamExists('fetchDocumentUsingGET', 'operationKey', operationKey)
            const localVarPath = `/document/{operationKey}/{nationalId}/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"nationalId"}}`, encodeURIComponent(String(nationalId)))
                .replace(`{${"operationKey"}}`, encodeURIComponent(String(operationKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch Document Loan
         * @param {string} authorization Authorization
         * @param {string} crmIdentifier crmIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchLoanDocumentUsingGET: async (authorization: string, crmIdentifier: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('fetchLoanDocumentUsingGET', 'authorization', authorization)
            // verify required parameter 'crmIdentifier' is not null or undefined
            assertParamExists('fetchLoanDocumentUsingGET', 'crmIdentifier', crmIdentifier)
            const localVarPath = `/document/loan/{crmIdentifier}`
                .replace(`{${"crmIdentifier"}}`, encodeURIComponent(String(crmIdentifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload Document
         * @param {string} authorization Authorization
         * @param {number} id id
         * @param {string} nationalId nationalId
         * @param {string} [operationKey] 
         * @param {any} [multipartFile] 
         * @param {string} [documentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocumentUsingPOST: async (authorization: string, id: number, nationalId: string, operationKey?: string, multipartFile?: any, documentType?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('uploadDocumentUsingPOST', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('uploadDocumentUsingPOST', 'id', id)
            // verify required parameter 'nationalId' is not null or undefined
            assertParamExists('uploadDocumentUsingPOST', 'nationalId', nationalId)
            const localVarPath = `/document/{nationalId}/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"nationalId"}}`, encodeURIComponent(String(nationalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


            if (operationKey !== undefined) { 
                localVarFormParams.append('operationKey', operationKey as any);
            }
    
            if (multipartFile !== undefined) { 
                localVarFormParams.append('multipartFile', multipartFile as any);
            }
    
            if (documentType !== undefined) { 
                localVarFormParams.append('documentType', documentType as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Uplaod Loan Document
         * @param {string} authorization Authorization
         * @param {string} crmIdentifier crmIdentifier
         * @param {string} [documentTypeEnum] 
         * @param {any} [multipartFile] 
         * @param {string} [operationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLoanDocumentUsingPOST: async (authorization: string, crmIdentifier: string, documentTypeEnum?: string, multipartFile?: any, operationId?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('uploadLoanDocumentUsingPOST', 'authorization', authorization)
            // verify required parameter 'crmIdentifier' is not null or undefined
            assertParamExists('uploadLoanDocumentUsingPOST', 'crmIdentifier', crmIdentifier)
            const localVarPath = `/document/loan/{crmIdentifier}`
                .replace(`{${"crmIdentifier"}}`, encodeURIComponent(String(crmIdentifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


            if (documentTypeEnum !== undefined) { 
                localVarFormParams.append('documentTypeEnum', documentTypeEnum as any);
            }
    
            if (multipartFile !== undefined) { 
                localVarFormParams.append('multipartFile', multipartFile as any);
            }
    
            if (operationId !== undefined) { 
                localVarFormParams.append('operationId', operationId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentControllerApi - functional programming interface
 * @export
 */
export const DocumentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Document Portability
         * @param {string} authorization Authorization
         * @param {number} [id] id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPortabilityDocumentUsingGET(authorization: string, id?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Resource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPortabilityDocumentUsingGET(authorization, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete Document Loan
         * @param {string} authorization Authorization
         * @param {number} documentId documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLoanDocumentUsingDELETE(authorization: string, documentId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanDocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLoanDocumentUsingDELETE(authorization, documentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Fetch Document
         * @param {string} authorization Authorization
         * @param {number} id id
         * @param {string} nationalId nationalId
         * @param {'INDEXA' | 'LOAN' | 'PORTABILITY'} operationKey operationKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchDocumentUsingGET(authorization: string, id: number, nationalId: string, operationKey: 'INDEXA' | 'LOAN' | 'PORTABILITY', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UploadedDocumentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchDocumentUsingGET(authorization, id, nationalId, operationKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Fetch Document Loan
         * @param {string} authorization Authorization
         * @param {string} crmIdentifier crmIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchLoanDocumentUsingGET(authorization: string, crmIdentifier: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadedLoanDocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchLoanDocumentUsingGET(authorization, crmIdentifier, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload Document
         * @param {string} authorization Authorization
         * @param {number} id id
         * @param {string} nationalId nationalId
         * @param {string} [operationKey] 
         * @param {any} [multipartFile] 
         * @param {string} [documentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadDocumentUsingPOST(authorization: string, id: number, nationalId: string, operationKey?: string, multipartFile?: any, documentType?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadedDocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadDocumentUsingPOST(authorization, id, nationalId, operationKey, multipartFile, documentType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Uplaod Loan Document
         * @param {string} authorization Authorization
         * @param {string} crmIdentifier crmIdentifier
         * @param {string} [documentTypeEnum] 
         * @param {any} [multipartFile] 
         * @param {string} [operationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadLoanDocumentUsingPOST(authorization: string, crmIdentifier: string, documentTypeEnum?: string, multipartFile?: any, operationId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanDocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadLoanDocumentUsingPOST(authorization, crmIdentifier, documentTypeEnum, multipartFile, operationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentControllerApi - factory interface
 * @export
 */
export const DocumentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Document Portability
         * @param {string} authorization Authorization
         * @param {number} [id] id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPortabilityDocumentUsingGET(authorization: string, id?: number, options?: any): AxiosPromise<Resource> {
            return localVarFp.createPortabilityDocumentUsingGET(authorization, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Document Loan
         * @param {string} authorization Authorization
         * @param {number} documentId documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLoanDocumentUsingDELETE(authorization: string, documentId: number, options?: any): AxiosPromise<LoanDocumentDto> {
            return localVarFp.deleteLoanDocumentUsingDELETE(authorization, documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch Document
         * @param {string} authorization Authorization
         * @param {number} id id
         * @param {string} nationalId nationalId
         * @param {'INDEXA' | 'LOAN' | 'PORTABILITY'} operationKey operationKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDocumentUsingGET(authorization: string, id: number, nationalId: string, operationKey: 'INDEXA' | 'LOAN' | 'PORTABILITY', options?: any): AxiosPromise<Array<UploadedDocumentDto>> {
            return localVarFp.fetchDocumentUsingGET(authorization, id, nationalId, operationKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch Document Loan
         * @param {string} authorization Authorization
         * @param {string} crmIdentifier crmIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchLoanDocumentUsingGET(authorization: string, crmIdentifier: string, options?: any): AxiosPromise<UploadedLoanDocumentDto> {
            return localVarFp.fetchLoanDocumentUsingGET(authorization, crmIdentifier, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload Document
         * @param {string} authorization Authorization
         * @param {number} id id
         * @param {string} nationalId nationalId
         * @param {string} [operationKey] 
         * @param {any} [multipartFile] 
         * @param {string} [documentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocumentUsingPOST(authorization: string, id: number, nationalId: string, operationKey?: string, multipartFile?: any, documentType?: string, options?: any): AxiosPromise<UploadedDocumentDto> {
            return localVarFp.uploadDocumentUsingPOST(authorization, id, nationalId, operationKey, multipartFile, documentType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Uplaod Loan Document
         * @param {string} authorization Authorization
         * @param {string} crmIdentifier crmIdentifier
         * @param {string} [documentTypeEnum] 
         * @param {any} [multipartFile] 
         * @param {string} [operationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLoanDocumentUsingPOST(authorization: string, crmIdentifier: string, documentTypeEnum?: string, multipartFile?: any, operationId?: string, options?: any): AxiosPromise<LoanDocumentDto> {
            return localVarFp.uploadLoanDocumentUsingPOST(authorization, crmIdentifier, documentTypeEnum, multipartFile, operationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentControllerApi - object-oriented interface
 * @export
 * @class DocumentControllerApi
 * @extends {BaseAPI}
 */
export class DocumentControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create Document Portability
     * @param {string} authorization Authorization
     * @param {number} [id] id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    public createPortabilityDocumentUsingGET(authorization: string, id?: number, options?: any) {
        return DocumentControllerApiFp(this.configuration).createPortabilityDocumentUsingGET(authorization, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Document Loan
     * @param {string} authorization Authorization
     * @param {number} documentId documentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    public deleteLoanDocumentUsingDELETE(authorization: string, documentId: number, options?: any) {
        return DocumentControllerApiFp(this.configuration).deleteLoanDocumentUsingDELETE(authorization, documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch Document
     * @param {string} authorization Authorization
     * @param {number} id id
     * @param {string} nationalId nationalId
     * @param {'INDEXA' | 'LOAN' | 'PORTABILITY'} operationKey operationKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    public fetchDocumentUsingGET(authorization: string, id: number, nationalId: string, operationKey: 'INDEXA' | 'LOAN' | 'PORTABILITY', options?: any) {
        return DocumentControllerApiFp(this.configuration).fetchDocumentUsingGET(authorization, id, nationalId, operationKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch Document Loan
     * @param {string} authorization Authorization
     * @param {string} crmIdentifier crmIdentifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    public fetchLoanDocumentUsingGET(authorization: string, crmIdentifier: string, options?: any) {
        return DocumentControllerApiFp(this.configuration).fetchLoanDocumentUsingGET(authorization, crmIdentifier, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload Document
     * @param {string} authorization Authorization
     * @param {number} id id
     * @param {string} nationalId nationalId
     * @param {string} [operationKey] 
     * @param {any} [multipartFile] 
     * @param {string} [documentType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    public uploadDocumentUsingPOST(authorization: string, id: number, nationalId: string, operationKey?: string, multipartFile?: any, documentType?: string, options?: any) {
        return DocumentControllerApiFp(this.configuration).uploadDocumentUsingPOST(authorization, id, nationalId, operationKey, multipartFile, documentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Uplaod Loan Document
     * @param {string} authorization Authorization
     * @param {string} crmIdentifier crmIdentifier
     * @param {string} [documentTypeEnum] 
     * @param {any} [multipartFile] 
     * @param {string} [operationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    public uploadLoanDocumentUsingPOST(authorization: string, crmIdentifier: string, documentTypeEnum?: string, multipartFile?: any, operationId?: string, options?: any) {
        return DocumentControllerApiFp(this.configuration).uploadLoanDocumentUsingPOST(authorization, crmIdentifier, documentTypeEnum, multipartFile, operationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IdentityControllerApi - axios parameter creator
 * @export
 */
export const IdentityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Validate SerialNumber CI
         * @param {string} authorization Authorization
         * @param {string} nationalId nationalId
         * @param {string} serialNumberId serialNumberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSerialCIUsingGET: async (authorization: string, nationalId: string, serialNumberId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('validateSerialCIUsingGET', 'authorization', authorization)
            // verify required parameter 'nationalId' is not null or undefined
            assertParamExists('validateSerialCIUsingGET', 'nationalId', nationalId)
            // verify required parameter 'serialNumberId' is not null or undefined
            assertParamExists('validateSerialCIUsingGET', 'serialNumberId', serialNumberId)
            const localVarPath = `/identity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (nationalId !== undefined) {
                localVarQueryParameter['nationalId'] = nationalId;
            }

            if (serialNumberId !== undefined) {
                localVarQueryParameter['serialNumberId'] = serialNumberId;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IdentityControllerApi - functional programming interface
 * @export
 */
export const IdentityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IdentityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Validate SerialNumber CI
         * @param {string} authorization Authorization
         * @param {string} nationalId nationalId
         * @param {string} serialNumberId serialNumberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateSerialCIUsingGET(authorization: string, nationalId: string, serialNumberId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateSerialCIUsingGET(authorization, nationalId, serialNumberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IdentityControllerApi - factory interface
 * @export
 */
export const IdentityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IdentityControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Validate SerialNumber CI
         * @param {string} authorization Authorization
         * @param {string} nationalId nationalId
         * @param {string} serialNumberId serialNumberId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateSerialCIUsingGET(authorization: string, nationalId: string, serialNumberId: string, options?: any): AxiosPromise<IdentityDto> {
            return localVarFp.validateSerialCIUsingGET(authorization, nationalId, serialNumberId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IdentityControllerApi - object-oriented interface
 * @export
 * @class IdentityControllerApi
 * @extends {BaseAPI}
 */
export class IdentityControllerApi extends BaseAPI {
    /**
     * 
     * @summary Validate SerialNumber CI
     * @param {string} authorization Authorization
     * @param {string} nationalId nationalId
     * @param {string} serialNumberId serialNumberId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityControllerApi
     */
    public validateSerialCIUsingGET(authorization: string, nationalId: string, serialNumberId: string, options?: any) {
        return IdentityControllerApiFp(this.configuration).validateSerialCIUsingGET(authorization, nationalId, serialNumberId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LandingControllerApi - axios parameter creator
 * @export
 */
export const LandingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new Landing
         * @param {string} authorization Authorization
         * @param {BannerDto} bannerDto bannerDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBannerUsingPOST: async (authorization: string, bannerDto: BannerDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createBannerUsingPOST', 'authorization', authorization)
            // verify required parameter 'bannerDto' is not null or undefined
            assertParamExists('createBannerUsingPOST', 'bannerDto', bannerDto)
            const localVarPath = `/landing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bannerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Landing Data
         * @param {string} authorization Authorization
         * @param {number} id id
         * @param {BannerDto} bannerDto bannerDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBannerUsingPUT: async (authorization: string, id: number, bannerDto: BannerDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateBannerUsingPUT', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateBannerUsingPUT', 'id', id)
            // verify required parameter 'bannerDto' is not null or undefined
            assertParamExists('updateBannerUsingPUT', 'bannerDto', bannerDto)
            const localVarPath = `/landing/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bannerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LandingControllerApi - functional programming interface
 * @export
 */
export const LandingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LandingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create new Landing
         * @param {string} authorization Authorization
         * @param {BannerDto} bannerDto bannerDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBannerUsingPOST(authorization: string, bannerDto: BannerDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BannerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBannerUsingPOST(authorization, bannerDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Landing Data
         * @param {string} authorization Authorization
         * @param {number} id id
         * @param {BannerDto} bannerDto bannerDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBannerUsingPUT(authorization: string, id: number, bannerDto: BannerDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BannerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBannerUsingPUT(authorization, id, bannerDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LandingControllerApi - factory interface
 * @export
 */
export const LandingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LandingControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create new Landing
         * @param {string} authorization Authorization
         * @param {BannerDto} bannerDto bannerDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBannerUsingPOST(authorization: string, bannerDto: BannerDto, options?: any): AxiosPromise<BannerDto> {
            return localVarFp.createBannerUsingPOST(authorization, bannerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Landing Data
         * @param {string} authorization Authorization
         * @param {number} id id
         * @param {BannerDto} bannerDto bannerDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBannerUsingPUT(authorization: string, id: number, bannerDto: BannerDto, options?: any): AxiosPromise<BannerDto> {
            return localVarFp.updateBannerUsingPUT(authorization, id, bannerDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LandingControllerApi - object-oriented interface
 * @export
 * @class LandingControllerApi
 * @extends {BaseAPI}
 */
export class LandingControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create new Landing
     * @param {string} authorization Authorization
     * @param {BannerDto} bannerDto bannerDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandingControllerApi
     */
    public createBannerUsingPOST(authorization: string, bannerDto: BannerDto, options?: any) {
        return LandingControllerApiFp(this.configuration).createBannerUsingPOST(authorization, bannerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Landing Data
     * @param {string} authorization Authorization
     * @param {number} id id
     * @param {BannerDto} bannerDto bannerDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandingControllerApi
     */
    public updateBannerUsingPUT(authorization: string, id: number, bannerDto: BannerDto, options?: any) {
        return LandingControllerApiFp(this.configuration).updateBannerUsingPUT(authorization, id, bannerDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * QuotationControllerApi - axios parameter creator
 * @export
 */
export const QuotationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Fetch Type Vehicle Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTypeVehicleUsingGET: async (authorization: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `quote/getTypeVehicle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch Data Form fields information 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchDataFormUsingGET: async (authorization: string, tipo_vehiculo: string, marca?: string, modelo?: string, region?: string, comuna?: string, sucursal?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tipo_vehiculo' is not null or undefined
            assertParamExists('fetchDataFormUsingGET', 'tipo_vehiculo', tipo_vehiculo);

            const localVarPath = `quote/getDataForms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            
            if (tipo_vehiculo !== undefined && String(tipo_vehiculo).length>0) {
                localVarQueryParameter['tipo_vehiculo'] = tipo_vehiculo;
            }

            if (marca !== undefined && String(marca).length>0) {
                localVarQueryParameter['marca'] = marca;
            }

            if (modelo !== undefined && String(modelo).length>0) {
                localVarQueryParameter['modelo'] = modelo;
            }

            if (region !== undefined && String(region).length>0) {
                localVarQueryParameter['region'] = region;
            }

            if (comuna !== undefined && String(comuna).length>0) {
                localVarQueryParameter['comuna'] = comuna;
            }

            if (sucursal !== undefined && String(sucursal).length>0) {
                localVarQueryParameter['sucursal'] = sucursal;
            }

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        fetchQuotationUsingPOST: async (authorization: string, quotationDTO: QuotationDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createLoanLeadUsingPOST', 'authorization', authorization)
            // verify required parameter 'loanDto' is not null or undefined
            assertParamExists('createLoanLeadUsingPOST', 'quotationDTO', quotationDTO)
            const localVarPath = `quote/lead`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(quotationDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }
    }
}

/**
 * LoanControllerApi - functional programming interface
 * @export
 */
export const QuotationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuotationControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * 
         * @summary Return the types of Vehicles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTypeVehicleUsingGet(authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdatedLeadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchTypeVehicleUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Return the values of the form for a Quote
         * @param {string} tipo_vehiculo
         * @param {string} marca
         * @param {string} modelo
         * @param {string} region
         * @param {string} comuna
         * @param {string} sucursal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataFormsFieldsUsingGet(authorization: string, tipo_vehiculo: string, marca?: string, modelo?: string, region?: string, comuna?: string, sucursal?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdatedLeadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchDataFormUsingGET(authorization, tipo_vehiculo, marca, modelo, region, comuna, sucursal, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates a quotation usinf formData
         * @param {*} [authorization] Auth Token.
         * @param {*} [quotation] Body payload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQuotationUsingPOST(authorization: string, quotation: QuotationDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdatedLeadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchQuotationUsingPOST(authorization, quotation, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
}

/**
 * QuotationControllerApi - object-oriented interface
 * @export
 * @class QuotationControllerApi
 * @extends {BaseAPI}
 */
export class QuotationControllerApi extends BaseAPI {
    /**
     * 
     * @summary Get types of vehicle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotationControllerApi
     */
    public getTypeVehicleUsingGet(authorization: string, options?: any) {
        return QuotationControllerApiFp(this.configuration).getTypeVehicleUsingGet(authorization, options).then((request) => request(this.axios, this.basePath));
    }

     /**
     * 
     * @summary Get from fields data for quotation
     * @param {string} tipo_vehiculo
     * @param {string} marca
     * @param {string} modelo
     * @param {string} region
     * @param {string} comuna
     * @param {string} sucursal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotationControllerApi
     */
    public getDataFormsFieldsUsingGet(authorization: string, tipo_vehiculo: string, marca?: string, modelo?: string, region?: string, comuna?: string, sucursal?: string, options?: any) {
        return QuotationControllerApiFp(this.configuration).getDataFormsFieldsUsingGet(authorization, tipo_vehiculo, marca, modelo, region, comuna, sucursal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get types of vehicle
     * @summary Creates a quotation usinf formData
     * @param {*} [authorization] Auth Token.
     * @param {*} [quotation] Body payload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotationControllerApi
     */
    public createQuotationUsingPOST(authorization: string, quotation: QuotationDto, options?: any) {
        return QuotationControllerApiFp(this.configuration).createQuotationUsingPOST(authorization, quotation, options).then((request) => request(this.axios, this.basePath));
    }
    
}


/**
 * LoanControllerApi - axios parameter creator
 * @export
 */
export const LoanControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new Loan Lead
         * @param {string} authorization Authorization
         * @param {LoanDto} loanDto loanDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLoanLeadUsingPOST: async (authorization: string, loanDto: LoanDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createLoanLeadUsingPOST', 'authorization', authorization)
            // verify required parameter 'loanDto' is not null or undefined
            assertParamExists('createLoanLeadUsingPOST', 'loanDto', loanDto)
            const localVarPath = `/loan/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loanDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch Banner Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchBannerUsingGET: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/loan/titles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch Financial Institutions - Refinancing
         * @param {string} authorization Authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFinancialInstitutionUsingGET: async (authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('fetchFinancialInstitutionUsingGET', 'authorization', authorization)
            const localVarPath = `/loan/refinancing/financial-institution`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Loan Simulation
         * @param {string} authorization Authorization
         * @param {number} downPayment 
         * @param {'NO' | 'SI'} flexibleQuotaEnum 
         * @param {number} installmentNumber 
         * @param {number} loanId 
         * @param {'CF' | 'CV'} quotaTypeEnum 
         * @param {boolean} reliefInsurance 
         * @param {boolean} unemploymentInsurance 
         * @param {number} vehicleValue 
         * @param {number} vehicleYear 
         * @param {string} [discountRate] 
         * @param {number} [percentageDiscount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanSimulationUsingGET: async (authorization: string, downPayment: number, flexibleQuotaEnum: 'NO' | 'SI', installmentNumber: number, loanId: number, quotaTypeEnum: 'CF' | 'CV', reliefInsurance: boolean, unemploymentInsurance: boolean, vehicleValue: number, vehicleYear: number, discountRate?: string, percentageDiscount?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getLoanSimulationUsingGET', 'authorization', authorization)
            // verify required parameter 'downPayment' is not null or undefined
            assertParamExists('getLoanSimulationUsingGET', 'downPayment', downPayment)
            // verify required parameter 'flexibleQuotaEnum' is not null or undefined
            assertParamExists('getLoanSimulationUsingGET', 'flexibleQuotaEnum', flexibleQuotaEnum)
            // verify required parameter 'installmentNumber' is not null or undefined
            assertParamExists('getLoanSimulationUsingGET', 'installmentNumber', installmentNumber)
            // verify required parameter 'loanId' is not null or undefined
            assertParamExists('getLoanSimulationUsingGET', 'loanId', loanId)
            // verify required parameter 'quotaTypeEnum' is not null or undefined
            assertParamExists('getLoanSimulationUsingGET', 'quotaTypeEnum', quotaTypeEnum)
            // verify required parameter 'reliefInsurance' is not null or undefined
            assertParamExists('getLoanSimulationUsingGET', 'reliefInsurance', reliefInsurance)
            // verify required parameter 'unemploymentInsurance' is not null or undefined
            assertParamExists('getLoanSimulationUsingGET', 'unemploymentInsurance', unemploymentInsurance)
            // verify required parameter 'vehicleValue' is not null or undefined
            assertParamExists('getLoanSimulationUsingGET', 'vehicleValue', vehicleValue)
            // verify required parameter 'vehicleYear' is not null or undefined
            assertParamExists('getLoanSimulationUsingGET', 'vehicleYear', vehicleYear)
            const localVarPath = `/loan/simulation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (discountRate !== undefined) {
                localVarQueryParameter['discountRate'] = discountRate;
            }

            if (downPayment !== undefined) {
                localVarQueryParameter['downPayment'] = downPayment;
            }

            if (flexibleQuotaEnum !== undefined) {
                localVarQueryParameter['flexibleQuotaEnum'] = flexibleQuotaEnum;
            }

            if (installmentNumber !== undefined) {
                localVarQueryParameter['installmentNumber'] = installmentNumber;
            }

            if (loanId !== undefined) {
                localVarQueryParameter['loanId'] = loanId;
            }

            if (percentageDiscount !== undefined) {
                localVarQueryParameter['percentageDiscount'] = percentageDiscount;
            }

            if (quotaTypeEnum !== undefined) {
                localVarQueryParameter['quotaTypeEnum'] = quotaTypeEnum;
            }

            if (reliefInsurance !== undefined) {
                localVarQueryParameter['reliefInsurance'] = reliefInsurance;
            }

            if (unemploymentInsurance !== undefined) {
                localVarQueryParameter['unemploymentInsurance'] = unemploymentInsurance;
            }

            if (vehicleValue !== undefined) {
                localVarQueryParameter['vehicleValue'] = vehicleValue;
            }

            if (vehicleYear !== undefined) {
                localVarQueryParameter['vehicleYear'] = vehicleYear;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Notification Document Loan
         * @param {string} authorization Authorization
         * @param {number} crmIdentifier crmIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationDocumentLoanCrmIdentifierUsingPOST: async (authorization: string, crmIdentifier: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('notificationDocumentLoanCrmIdentifierUsingPOST', 'authorization', authorization)
            // verify required parameter 'crmIdentifier' is not null or undefined
            assertParamExists('notificationDocumentLoanCrmIdentifierUsingPOST', 'crmIdentifier', crmIdentifier)
            const localVarPath = `/loan/{crmIdentifier}/notification-document`
                .replace(`{${"crmIdentifier"}}`, encodeURIComponent(String(crmIdentifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Notification Document Loan
         * @param {'WITHOUT_DOCUMENT' | 'WITH_DOCUMENT'} action action
         * @param {string} authorization Authorization
         * @param {string} crmIdentifier crmIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationLoanDocumentUsingGET: async (action: 'WITHOUT_DOCUMENT' | 'WITH_DOCUMENT', authorization: string, crmIdentifier: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'action' is not null or undefined
            assertParamExists('notificationLoanDocumentUsingGET', 'action', action)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('notificationLoanDocumentUsingGET', 'authorization', authorization)
            // verify required parameter 'crmIdentifier' is not null or undefined
            assertParamExists('notificationLoanDocumentUsingGET', 'crmIdentifier', crmIdentifier)
            const localVarPath = `/loan/notification/{crmIdentifier}`
                .replace(`{${"crmIdentifier"}}`, encodeURIComponent(String(crmIdentifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new Refinancing
         * @param {string} authorization Authorization
         * @param {RequestRefinancingDto} requestRefinancingDto requestRefinancingDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refinancingUsingPOST: async (authorization: string, requestRefinancingDto: RequestRefinancingDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('refinancingUsingPOST', 'authorization', authorization)
            // verify required parameter 'requestRefinancingDto' is not null or undefined
            assertParamExists('refinancingUsingPOST', 'requestRefinancingDto', requestRefinancingDto)
            const localVarPath = `/loan/refinancing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestRefinancingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Loan Lead
         * @param {string} authorization Authorization
         * @param {number} id id
         * @param {LoanDto} loanDto loanDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoanLeadUsingPATCH: async (authorization: string, id: number, loanDto: LoanDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateLoanLeadUsingPATCH', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateLoanLeadUsingPATCH', 'id', id)
            // verify required parameter 'loanDto' is not null or undefined
            assertParamExists('updateLoanLeadUsingPATCH', 'loanDto', loanDto)
            const localVarPath = `/loan/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loanDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanControllerApi - functional programming interface
 * @export
 */
export const LoanControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoanControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create new Loan Lead
         * @param {string} authorization Authorization
         * @param {LoanDto} loanDto loanDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLoanLeadUsingPOST(authorization: string, loanDto: LoanDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdatedLeadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLoanLeadUsingPOST(authorization, loanDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Fetch Banner Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchBannerUsingGET(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BannerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchBannerUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Fetch Financial Institutions - Refinancing
         * @param {string} authorization Authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchFinancialInstitutionUsingGET(authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FinancialInstitutionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchFinancialInstitutionUsingGET(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Loan Simulation
         * @param {string} authorization Authorization
         * @param {number} downPayment 
         * @param {'NO' | 'SI'} flexibleQuotaEnum 
         * @param {number} installmentNumber 
         * @param {number} loanId 
         * @param {'CF' | 'CV'} quotaTypeEnum 
         * @param {boolean} reliefInsurance 
         * @param {boolean} unemploymentInsurance 
         * @param {number} vehicleValue 
         * @param {number} vehicleYear 
         * @param {string} [discountRate] 
         * @param {number} [percentageDiscount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoanSimulationUsingGET(authorization: string, downPayment: number, flexibleQuotaEnum: 'NO' | 'SI', installmentNumber: number, loanId: number, quotaTypeEnum: 'CF' | 'CV', reliefInsurance: boolean, unemploymentInsurance: boolean, vehicleValue: number, vehicleYear: number, discountRate?: string, percentageDiscount?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimulationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoanSimulationUsingGET(authorization, downPayment, flexibleQuotaEnum, installmentNumber, loanId, quotaTypeEnum, reliefInsurance, unemploymentInsurance, vehicleValue, vehicleYear, discountRate, percentageDiscount, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Notification Document Loan
         * @param {string} authorization Authorization
         * @param {number} crmIdentifier crmIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationDocumentLoanCrmIdentifierUsingPOST(authorization: string, crmIdentifier: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationDocumentLoanCrmIdentifierUsingPOST(authorization, crmIdentifier, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Notification Document Loan
         * @param {'WITHOUT_DOCUMENT' | 'WITH_DOCUMENT'} action action
         * @param {string} authorization Authorization
         * @param {string} crmIdentifier crmIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationLoanDocumentUsingGET(action: 'WITHOUT_DOCUMENT' | 'WITH_DOCUMENT', authorization: string, crmIdentifier: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationLoanDocumentUsingGET(action, authorization, crmIdentifier, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new Refinancing
         * @param {string} authorization Authorization
         * @param {RequestRefinancingDto} requestRefinancingDto requestRefinancingDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refinancingUsingPOST(authorization: string, requestRefinancingDto: RequestRefinancingDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseRefinancingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refinancingUsingPOST(authorization, requestRefinancingDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Loan Lead
         * @param {string} authorization Authorization
         * @param {number} id id
         * @param {LoanDto} loanDto loanDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLoanLeadUsingPATCH(authorization: string, id: number, loanDto: LoanDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdatedLeadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLoanLeadUsingPATCH(authorization, id, loanDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LoanControllerApi - factory interface
 * @export
 */
export const LoanControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoanControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create new Loan Lead
         * @param {string} authorization Authorization
         * @param {LoanDto} loanDto loanDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLoanLeadUsingPOST(authorization: string, loanDto: LoanDto, options?: any): AxiosPromise<UpdatedLeadDto> {
            return localVarFp.createLoanLeadUsingPOST(authorization, loanDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch Banner Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchBannerUsingGET(options?: any): AxiosPromise<BannerDto> {
            return localVarFp.fetchBannerUsingGET(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch Financial Institutions - Refinancing
         * @param {string} authorization Authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFinancialInstitutionUsingGET(authorization: string, options?: any): AxiosPromise<Array<FinancialInstitutionDto>> {
            return localVarFp.fetchFinancialInstitutionUsingGET(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Loan Simulation
         * @param {string} authorization Authorization
         * @param {number} downPayment 
         * @param {'NO' | 'SI'} flexibleQuotaEnum 
         * @param {number} installmentNumber 
         * @param {number} loanId 
         * @param {'CF' | 'CV'} quotaTypeEnum 
         * @param {boolean} reliefInsurance 
         * @param {boolean} unemploymentInsurance 
         * @param {number} vehicleValue 
         * @param {number} vehicleYear 
         * @param {string} [discountRate] 
         * @param {number} [percentageDiscount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanSimulationUsingGET(authorization: string, downPayment: number, flexibleQuotaEnum: 'NO' | 'SI', installmentNumber: number, loanId: number, quotaTypeEnum: 'CF' | 'CV', reliefInsurance: boolean, unemploymentInsurance: boolean, vehicleValue: number, vehicleYear: number, discountRate?: string, percentageDiscount?: number, options?: any): AxiosPromise<SimulationResponseDto> {
            return localVarFp.getLoanSimulationUsingGET(authorization, downPayment, flexibleQuotaEnum, installmentNumber, loanId, quotaTypeEnum, reliefInsurance, unemploymentInsurance, vehicleValue, vehicleYear, discountRate, percentageDiscount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Notification Document Loan
         * @param {string} authorization Authorization
         * @param {number} crmIdentifier crmIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationDocumentLoanCrmIdentifierUsingPOST(authorization: string, crmIdentifier: number, options?: any): AxiosPromise<LoanDto> {
            return localVarFp.notificationDocumentLoanCrmIdentifierUsingPOST(authorization, crmIdentifier, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Notification Document Loan
         * @param {'WITHOUT_DOCUMENT' | 'WITH_DOCUMENT'} action action
         * @param {string} authorization Authorization
         * @param {string} crmIdentifier crmIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationLoanDocumentUsingGET(action: 'WITHOUT_DOCUMENT' | 'WITH_DOCUMENT', authorization: string, crmIdentifier: string, options?: any): AxiosPromise<NotificationDocument> {
            return localVarFp.notificationLoanDocumentUsingGET(action, authorization, crmIdentifier, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new Refinancing
         * @param {string} authorization Authorization
         * @param {RequestRefinancingDto} requestRefinancingDto requestRefinancingDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refinancingUsingPOST(authorization: string, requestRefinancingDto: RequestRefinancingDto, options?: any): AxiosPromise<ResponseRefinancingDto> {
            return localVarFp.refinancingUsingPOST(authorization, requestRefinancingDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Loan Lead
         * @param {string} authorization Authorization
         * @param {number} id id
         * @param {LoanDto} loanDto loanDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLoanLeadUsingPATCH(authorization: string, id: number, loanDto: LoanDto, options?: any): AxiosPromise<UpdatedLeadDto> {
            return localVarFp.updateLoanLeadUsingPATCH(authorization, id, loanDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LoanControllerApi - object-oriented interface
 * @export
 * @class LoanControllerApi
 * @extends {BaseAPI}
 */
export class LoanControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create new Loan Lead
     * @param {string} authorization Authorization
     * @param {LoanDto} loanDto loanDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanControllerApi
     */
    public createLoanLeadUsingPOST(authorization: string, loanDto: LoanDto, options?: any) {
        return LoanControllerApiFp(this.configuration).createLoanLeadUsingPOST(authorization, loanDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch Banner Data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanControllerApi
     */
    public fetchBannerUsingGET(options?: any) {
        return LoanControllerApiFp(this.configuration).fetchBannerUsingGET(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch Financial Institutions - Refinancing
     * @param {string} authorization Authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanControllerApi
     */
    public fetchFinancialInstitutionUsingGET(authorization: string, options?: any) {
        return LoanControllerApiFp(this.configuration).fetchFinancialInstitutionUsingGET(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Loan Simulation
     * @param {string} authorization Authorization
     * @param {number} downPayment 
     * @param {'NO' | 'SI'} flexibleQuotaEnum 
     * @param {number} installmentNumber 
     * @param {number} loanId 
     * @param {'CF' | 'CV'} quotaTypeEnum 
     * @param {boolean} reliefInsurance 
     * @param {boolean} unemploymentInsurance 
     * @param {number} vehicleValue 
     * @param {number} vehicleYear 
     * @param {string} [discountRate] 
     * @param {number} [percentageDiscount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanControllerApi
     */
    public getLoanSimulationUsingGET(authorization: string, downPayment: number, flexibleQuotaEnum: 'NO' | 'SI', installmentNumber: number, loanId: number, quotaTypeEnum: 'CF' | 'CV', reliefInsurance: boolean, unemploymentInsurance: boolean, vehicleValue: number, vehicleYear: number, discountRate?: string, percentageDiscount?: number, options?: any) {
        return LoanControllerApiFp(this.configuration).getLoanSimulationUsingGET(authorization, downPayment, flexibleQuotaEnum, installmentNumber, loanId, quotaTypeEnum, reliefInsurance, unemploymentInsurance, vehicleValue, vehicleYear, discountRate, percentageDiscount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Notification Document Loan
     * @param {string} authorization Authorization
     * @param {number} crmIdentifier crmIdentifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanControllerApi
     */
    public notificationDocumentLoanCrmIdentifierUsingPOST(authorization: string, crmIdentifier: number, options?: any) {
        return LoanControllerApiFp(this.configuration).notificationDocumentLoanCrmIdentifierUsingPOST(authorization, crmIdentifier, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Notification Document Loan
     * @param {'WITHOUT_DOCUMENT' | 'WITH_DOCUMENT'} action action
     * @param {string} authorization Authorization
     * @param {string} crmIdentifier crmIdentifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanControllerApi
     */
    public notificationLoanDocumentUsingGET(action: 'WITHOUT_DOCUMENT' | 'WITH_DOCUMENT', authorization: string, crmIdentifier: string, options?: any) {
        return LoanControllerApiFp(this.configuration).notificationLoanDocumentUsingGET(action, authorization, crmIdentifier, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new Refinancing
     * @param {string} authorization Authorization
     * @param {RequestRefinancingDto} requestRefinancingDto requestRefinancingDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanControllerApi
     */
    public refinancingUsingPOST(authorization: string, requestRefinancingDto: RequestRefinancingDto, options?: any) {
        return LoanControllerApiFp(this.configuration).refinancingUsingPOST(authorization, requestRefinancingDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Loan Lead
     * @param {string} authorization Authorization
     * @param {number} id id
     * @param {LoanDto} loanDto loanDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanControllerApi
     */
    public updateLoanLeadUsingPATCH(authorization: string, id: number, loanDto: LoanDto, options?: any) {
        return LoanControllerApiFp(this.configuration).updateLoanLeadUsingPATCH(authorization, id, loanDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OperationHandlerApi - axios parameter creator
 * @export
 */
export const OperationHandlerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary handle
         * @param {{ [key: string]: string; }} [body] body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleUsingGET: async (body?: { [key: string]: string; }, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary handle
         * @param {{ [key: string]: string; }} [body] body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleUsingGET1: async (body?: { [key: string]: string; }, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator/health/**`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary handle
         * @param {{ [key: string]: string; }} [body] body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleUsingGET2: async (body?: { [key: string]: string; }, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OperationHandlerApi - functional programming interface
 * @export
 */
export const OperationHandlerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OperationHandlerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary handle
         * @param {{ [key: string]: string; }} [body] body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleUsingGET(body?: { [key: string]: string; }, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleUsingGET(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary handle
         * @param {{ [key: string]: string; }} [body] body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleUsingGET1(body?: { [key: string]: string; }, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleUsingGET1(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary handle
         * @param {{ [key: string]: string; }} [body] body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleUsingGET2(body?: { [key: string]: string; }, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleUsingGET2(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OperationHandlerApi - factory interface
 * @export
 */
export const OperationHandlerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OperationHandlerApiFp(configuration)
    return {
        /**
         * 
         * @summary handle
         * @param {{ [key: string]: string; }} [body] body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleUsingGET(body?: { [key: string]: string; }, options?: any): AxiosPromise<object> {
            return localVarFp.handleUsingGET(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary handle
         * @param {{ [key: string]: string; }} [body] body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleUsingGET1(body?: { [key: string]: string; }, options?: any): AxiosPromise<object> {
            return localVarFp.handleUsingGET1(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary handle
         * @param {{ [key: string]: string; }} [body] body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleUsingGET2(body?: { [key: string]: string; }, options?: any): AxiosPromise<object> {
            return localVarFp.handleUsingGET2(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OperationHandlerApi - object-oriented interface
 * @export
 * @class OperationHandlerApi
 * @extends {BaseAPI}
 */
export class OperationHandlerApi extends BaseAPI {
    /**
     * 
     * @summary handle
     * @param {{ [key: string]: string; }} [body] body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationHandlerApi
     */
    public handleUsingGET(body?: { [key: string]: string; }, options?: any) {
        return OperationHandlerApiFp(this.configuration).handleUsingGET(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary handle
     * @param {{ [key: string]: string; }} [body] body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationHandlerApi
     */
    public handleUsingGET1(body?: { [key: string]: string; }, options?: any) {
        return OperationHandlerApiFp(this.configuration).handleUsingGET1(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary handle
     * @param {{ [key: string]: string; }} [body] body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OperationHandlerApi
     */
    public handleUsingGET2(body?: { [key: string]: string; }, options?: any) {
        return OperationHandlerApiFp(this.configuration).handleUsingGET2(body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PortabilityControllerApi - axios parameter creator
 * @export
 */
export const PortabilityControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new Portability Lead
         * @param {string} authorization Authorization
         * @param {PortabilityDto} portabilityDto portabilityDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPortabilityLeadUsingPOST: async (authorization: string, portabilityDto: PortabilityDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createPortabilityLeadUsingPOST', 'authorization', authorization)
            // verify required parameter 'portabilityDto' is not null or undefined
            assertParamExists('createPortabilityLeadUsingPOST', 'portabilityDto', portabilityDto)
            const localVarPath = `/portability/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(portabilityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Portability Lead
         * @param {string} authorization Authorization
         * @param {number} id id
         * @param {PortabilityDto} portabilityDto portabilityDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePortabilityLeadUsingPATCH: async (authorization: string, id: number, portabilityDto: PortabilityDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updatePortabilityLeadUsingPATCH', 'authorization', authorization)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePortabilityLeadUsingPATCH', 'id', id)
            // verify required parameter 'portabilityDto' is not null or undefined
            assertParamExists('updatePortabilityLeadUsingPATCH', 'portabilityDto', portabilityDto)
            const localVarPath = `/portability/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(portabilityDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PortabilityControllerApi - functional programming interface
 * @export
 */
export const PortabilityControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PortabilityControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create new Portability Lead
         * @param {string} authorization Authorization
         * @param {PortabilityDto} portabilityDto portabilityDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPortabilityLeadUsingPOST(authorization: string, portabilityDto: PortabilityDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatedLeadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPortabilityLeadUsingPOST(authorization, portabilityDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Portability Lead
         * @param {string} authorization Authorization
         * @param {number} id id
         * @param {PortabilityDto} portabilityDto portabilityDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePortabilityLeadUsingPATCH(authorization: string, id: number, portabilityDto: PortabilityDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdatedLeadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePortabilityLeadUsingPATCH(authorization, id, portabilityDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PortabilityControllerApi - factory interface
 * @export
 */
export const PortabilityControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PortabilityControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create new Portability Lead
         * @param {string} authorization Authorization
         * @param {PortabilityDto} portabilityDto portabilityDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPortabilityLeadUsingPOST(authorization: string, portabilityDto: PortabilityDto, options?: any): AxiosPromise<CreatedLeadDto> {
            return localVarFp.createPortabilityLeadUsingPOST(authorization, portabilityDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Portability Lead
         * @param {string} authorization Authorization
         * @param {number} id id
         * @param {PortabilityDto} portabilityDto portabilityDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePortabilityLeadUsingPATCH(authorization: string, id: number, portabilityDto: PortabilityDto, options?: any): AxiosPromise<UpdatedLeadDto> {
            return localVarFp.updatePortabilityLeadUsingPATCH(authorization, id, portabilityDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PortabilityControllerApi - object-oriented interface
 * @export
 * @class PortabilityControllerApi
 * @extends {BaseAPI}
 */
export class PortabilityControllerApi extends BaseAPI {
    /**
     * 
     * @summary Create new Portability Lead
     * @param {string} authorization Authorization
     * @param {PortabilityDto} portabilityDto portabilityDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortabilityControllerApi
     */
    public createPortabilityLeadUsingPOST(authorization: string, portabilityDto: PortabilityDto, options?: any) {
        return PortabilityControllerApiFp(this.configuration).createPortabilityLeadUsingPOST(authorization, portabilityDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Portability Lead
     * @param {string} authorization Authorization
     * @param {number} id id
     * @param {PortabilityDto} portabilityDto portabilityDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortabilityControllerApi
     */
    public updatePortabilityLeadUsingPATCH(authorization: string, id: number, portabilityDto: PortabilityDto, options?: any) {
        return PortabilityControllerApiFp(this.configuration).updatePortabilityLeadUsingPATCH(authorization, id, portabilityDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RefinancingControllerApi - axios parameter creator
 * @export
 */
export const RefinancingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Financial Institutions List
         * @param {string} authorization Authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFinancialInstitutionUsingGET1: async (authorization: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('fetchFinancialInstitutionUsingGET1', 'authorization', authorization)
            const localVarPath = `/refinancing/financial-institution`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary New Refinancing
         * @param {string} authorization Authorization
         * @param {RequestRefinancingDto} requestRefinancingDto requestRefinancingDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refinancingUsingPOST1: async (authorization: string, requestRefinancingDto: RequestRefinancingDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('refinancingUsingPOST1', 'authorization', authorization)
            // verify required parameter 'requestRefinancingDto' is not null or undefined
            assertParamExists('refinancingUsingPOST1', 'requestRefinancingDto', requestRefinancingDto)
            const localVarPath = `/refinancing/refinancing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestRefinancingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RefinancingControllerApi - functional programming interface
 * @export
 */
export const RefinancingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RefinancingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Financial Institutions List
         * @param {string} authorization Authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchFinancialInstitutionUsingGET1(authorization: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FinancialInstitutionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchFinancialInstitutionUsingGET1(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary New Refinancing
         * @param {string} authorization Authorization
         * @param {RequestRefinancingDto} requestRefinancingDto requestRefinancingDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refinancingUsingPOST1(authorization: string, requestRefinancingDto: RequestRefinancingDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseRefinancingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refinancingUsingPOST1(authorization, requestRefinancingDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RefinancingControllerApi - factory interface
 * @export
 */
export const RefinancingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RefinancingControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Financial Institutions List
         * @param {string} authorization Authorization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFinancialInstitutionUsingGET1(authorization: string, options?: any): AxiosPromise<Array<FinancialInstitutionDto>> {
            return localVarFp.fetchFinancialInstitutionUsingGET1(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary New Refinancing
         * @param {string} authorization Authorization
         * @param {RequestRefinancingDto} requestRefinancingDto requestRefinancingDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refinancingUsingPOST1(authorization: string, requestRefinancingDto: RequestRefinancingDto, options?: any): AxiosPromise<ResponseRefinancingDto> {
            return localVarFp.refinancingUsingPOST1(authorization, requestRefinancingDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RefinancingControllerApi - object-oriented interface
 * @export
 * @class RefinancingControllerApi
 * @extends {BaseAPI}
 */
export class RefinancingControllerApi extends BaseAPI {
    /**
     * 
     * @summary Financial Institutions List
     * @param {string} authorization Authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefinancingControllerApi
     */
    public fetchFinancialInstitutionUsingGET1(authorization: string, options?: any) {
        return RefinancingControllerApiFp(this.configuration).fetchFinancialInstitutionUsingGET1(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary New Refinancing
     * @param {string} authorization Authorization
     * @param {RequestRefinancingDto} requestRefinancingDto requestRefinancingDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefinancingControllerApi
     */
    public refinancingUsingPOST1(authorization: string, requestRefinancingDto: RequestRefinancingDto, options?: any) {
        return RefinancingControllerApiFp(this.configuration).refinancingUsingPOST1(authorization, requestRefinancingDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StorageControllerApi - axios parameter creator
 * @export
 */
export const StorageControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary uploadFile
         * @param {string} authorization Authorization
         * @param {'INDEXA' | 'LOAN' | 'PORTABILITY'} operationId operationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFileUsingPOST: async (authorization: string, operationId: 'INDEXA' | 'LOAN' | 'PORTABILITY', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('uploadFileUsingPOST', 'authorization', authorization)
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('uploadFileUsingPOST', 'operationId', operationId)
            const localVarPath = `/file/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (operationId !== undefined) {
                localVarQueryParameter['operationId'] = operationId;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StorageControllerApi - functional programming interface
 * @export
 */
export const StorageControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StorageControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary uploadFile
         * @param {string} authorization Authorization
         * @param {'INDEXA' | 'LOAN' | 'PORTABILITY'} operationId operationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFileUsingPOST(authorization: string, operationId: 'INDEXA' | 'LOAN' | 'PORTABILITY', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFileUsingPOST(authorization, operationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StorageControllerApi - factory interface
 * @export
 */
export const StorageControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StorageControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary uploadFile
         * @param {string} authorization Authorization
         * @param {'INDEXA' | 'LOAN' | 'PORTABILITY'} operationId operationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFileUsingPOST(authorization: string, operationId: 'INDEXA' | 'LOAN' | 'PORTABILITY', options?: any): AxiosPromise<string> {
            return localVarFp.uploadFileUsingPOST(authorization, operationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StorageControllerApi - object-oriented interface
 * @export
 * @class StorageControllerApi
 * @extends {BaseAPI}
 */
export class StorageControllerApi extends BaseAPI {
    /**
     * 
     * @summary uploadFile
     * @param {string} authorization Authorization
     * @param {'INDEXA' | 'LOAN' | 'PORTABILITY'} operationId operationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StorageControllerApi
     */
    public uploadFileUsingPOST(authorization: string, operationId: 'INDEXA' | 'LOAN' | 'PORTABILITY', options?: any) {
        return StorageControllerApiFp(this.configuration).uploadFileUsingPOST(authorization, operationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WebMvcLinksHandlerApi - axios parameter creator
 * @export
 */
export const WebMvcLinksHandlerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary links
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linksUsingGET: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebMvcLinksHandlerApi - functional programming interface
 * @export
 */
export const WebMvcLinksHandlerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebMvcLinksHandlerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary links
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linksUsingGET(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: { [key: string]: Link; }; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linksUsingGET(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WebMvcLinksHandlerApi - factory interface
 * @export
 */
export const WebMvcLinksHandlerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebMvcLinksHandlerApiFp(configuration)
    return {
        /**
         * 
         * @summary links
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linksUsingGET(options?: any): AxiosPromise<{ [key: string]: { [key: string]: Link; }; }> {
            return localVarFp.linksUsingGET(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebMvcLinksHandlerApi - object-oriented interface
 * @export
 * @class WebMvcLinksHandlerApi
 * @extends {BaseAPI}
 */
export class WebMvcLinksHandlerApi extends BaseAPI {
    /**
     * 
     * @summary links
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebMvcLinksHandlerApi
     */
    public linksUsingGET(options?: any) {
        return WebMvcLinksHandlerApiFp(this.configuration).linksUsingGET(options).then((request) => request(this.axios, this.basePath));
    }
}


